import { render, staticRenderFns } from "./UserFollowing.vue?vue&type=template&id=800239e0&"
import script from "./UserFollowing.vue?vue&type=script&lang=js&"
export * from "./UserFollowing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports